import React from 'react';
import { ActionIcon, Card, Text, useMantineTheme, Menu, Group, SimpleGrid, Badge } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";
import { numberFormatter, sqlDateToHumanDate, getObjectParam2, safeValue } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import SortSegmentedControl from "../../components/general/SortSegmentedControl";

const StokItemRusakCard = ({ stateData, stateSortList, stateSortSelected, fnSort, fnSelectedDataInStock, fnSelectedDataView }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>

            <SortSegmentedControl
                stateSortList={stateSortList}
                stateSortSelected={stateSortSelected}
                fnSort={fnSort}
                stateStyle={{ marginBottom: theme.spacing.md }}
            />

            <SimpleGrid
                cols={1}
                spacing='md'
                breakpoints={[
                    { minWidth: 'xl', cols: 3, spacing: 'md' },
                    { minWidth: 'lg', cols: 2, spacing: 'md' },
                    { minWidth: 'md', cols: 2, spacing: 'md' },
                    { minWidth: 'sm', cols: 2, spacing: 'md' },
                    { minWidth: 'xs', cols: 2, spacing: 'md' },
                ]}
            >
                {Object.keys(stateData).map((key, index) => {
                    return (
                        <Card
                            key={key}
                            shadow=''
                            radius="md"
                            withBorder={true}

                            style={{
                                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                overflow: 'unset',
                                cursor: 'pointer',
                            }}

                            onClick={() => {
                                fnSelectedDataView(stateData[key]);
                            }}
                        >
                            <Card.Section p='sm'>
                                <Text size="sm">
                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockCategory.caption}
                                        stateContent={<Group position='apart' noWrap>
                                            <Text lineClamp={2}>{stateData[key].stock_category_name}</Text>

                                            <Menu shadow="md">
                                                <Menu.Target>
                                                    <ActionIcon
                                                        size='md'
                                                        variant="subtle"
                                                        radius='xl'

                                                        sx={{
                                                            '&:hover': {
                                                                backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[5]
                                                            },
                                                        }}

                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <IconDotsVertical size='1rem' />
                                                    </ActionIcon>
                                                </Menu.Target>

                                                <Menu.Dropdown>
                                                    <Menu.Item
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            fnSelectedDataInStock(stateData[key])
                                                        }}
                                                    >
                                                        Masukkan ke stok
                                                    </Menu.Item>
                                                </Menu.Dropdown>
                                            </Menu>
                                        </Group>}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockCategorySub.caption}
                                        stateContent={<Text lineClamp={2}>{stateData[key].stock_category_sub_name}</Text>}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Kerusakan'
                                        stateContent={
                                            <Text
                                                lineClamp={1}
                                                sx={{ wordBreak: 'break-word' }}
                                            >
                                                {stateData[key].stock_rusak_info}
                                            </Text>
                                        }
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockSupplier.caption}
                                        stateContent={<Text lineClamp={2}>{stateData[key].supplier_name}</Text>}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockTanggalBeli.caption}
                                        stateContent={sqlDateToHumanDate({
                                            stateDate: stateData[key].stock_tanggal_beli,
                                            stateWithTime: false,
                                            stateLang: 'id',
                                            stateIsShort: false,
                                            stateDay: false,
                                            stateDefaultValue: ' - ',
                                            stateDateType: 'day'
                                        })}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockHargaBeli.caption}
                                        stateContent={'Rp ' + numberFormatter({ stateValue: stateData[key].stock_harga_beli })}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockHargaJual.caption}
                                        stateContent={'Rp ' + numberFormatter({ stateValue: stateData[key].stock_harga_jual })}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockMasaGaransiType.caption}
                                        stateContent={getObjectParam2(utils.masaGaransi, stateData[key].stock_masa_garansi_type, 'caption', '-')}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockMasaGaransi.caption}
                                        stateContent={
                                            <Text>
                                                <Text>
                                                    {safeValue(stateData[key].stock_masa_garansi_bulan, '0') + ' Bulan'}
                                                </Text>
                                                <Text>
                                                    {safeValue(stateData[key].stock_masa_garansi_hari, '0') + ' Hari'}
                                                </Text>
                                            </Text>
                                        }
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Serial Number'
                                        stateContent={
                                            <Text
                                                lineClamp={2}
                                                sx={{
                                                    wordBreak: 'break-word'
                                                }}
                                            >
                                                {stateData[key].stock_serial_number ? stateData[key].stock_serial_number : ''}
                                            </Text>
                                        }
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockJumlah.caption}
                                        stateContent={numberFormatter({ stateValue: stateData[key].stock_jumlah })}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockTanda.caption}
                                        stateContent={
                                            <React.Fragment>
                                                <Badge
                                                    size='md'
                                                    color={getObjectParam2(utils.stockItemStatus, stateData[key].stock_status, 'color', 'gray')}
                                                >
                                                    {getObjectParam2(utils.stockItemStatus, stateData[key].stock_status, 'caption', ' - ')}
                                                </Badge>
                                            </React.Fragment>
                                        }
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.stockIsActive.caption}
                                        stateContent={stateData[key].stock_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                                        stateDivider={false}
                                    />
                                </Text>
                            </Card.Section>
                        </Card>
                    )
                })}
            </SimpleGrid>
        </React.Fragment>
    )
}

export default React.memo(StokItemRusakCard);